import { Injectable, inject } from '@angular/core';
import { AuthService } from '@vdms-hq/auth';
import { ActivatedClientService, Permission } from '@vdms-hq/auth';
import { IStepOption } from 'ngx-ui-tour-md-menu';
import { TOUR_STEPS } from '../models/tour-settings.config';
import { combineLatest, map, Observable } from 'rxjs';

/**
 * Filters tour steps based on user permissions and client configuration.
 * Steps that don't apply to the current user (e.g. cart for users without cart permission)
 * are removed from the tour sequence.
 */
@Injectable({ providedIn: 'root' })
export class TourStepFilterService {
  private authService = inject(AuthService);
  private activatedClientService = inject(ActivatedClientService);

  /**
   * Returns filtered tour steps based on the current user's permissions and client configuration.
   */
  filteredSteps$: Observable<IStepOption[]> = combineLatest([
    this.authService.authDefinite$,
    this.activatedClientService.permissions$,
  ]).pipe(
    map(([auth, permissions]) => {
      return TOUR_STEPS.filter((step) => {
        switch (step.anchorId) {
          case 'clientSwitcher':
            return auth.clients.length > 1;
          case 'cartButton':
            return permissions.includes(Permission.SHOPPING_CART);
          case 'menuLibrary':
            return permissions.includes(Permission.BROWSE_ASSETS_LIBRARY);
          default:
            return true;
        }
      });
    }),
  );
}
